let timeout = 0

export function updateWithTimeout(cb: () => void) {
  window.clearTimeout(timeout)

  timeout = window.setTimeout(() => {
    cb()
  }, 700)
}
